/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_TitleInputs */

const en_mk_hero_title = /** @type {(inputs: Mk_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From idea to app. One step at a time.`)
};

const id_mk_hero_title = /** @type {(inputs: Mk_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari ide ke aplikasi. Selangkah demi selangkah.`)
};

/**
* | output |
* | --- |
* | "From idea to app. One step at a time." |
*
* @param {Mk_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_title = /** @type {((inputs?: Mk_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_title(inputs)
	return en_mk_hero_title(inputs)
});